import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-skeleton-loader",
  templateUrl: "./skeleton-loader.component.html",
  styleUrls: ["./skeleton-loader.component.scss"],
  standalone: false,
})
export class SkeletonLoaderComponent implements OnInit, OnChanges {
  @Input() type: "text" | "card" | "list" | "table" | "chart" | "form" | "custom" =
    "text";
  @Input() rows: number = 1;
  @Input() columns: number = 1;
  @Input() height: string = "20px";
  @Input() width: string = "100%";
  @Input() borderRadius: string = "4px";
  @Input() animation: "pulse" | "wave" | "none" = "pulse";
  @Input() showAvatar: boolean = false;
  @Input() avatarSize: string = "40px";

  /** Stable arrays — recreating these every CD cycle freezes the page. */
  rowsArray: number[] = [0];
  columnsArray: number[] = [0];
  /** Stable chart bar heights (avoid Math.random() in the template). */
  chartBarHeights: string[] = ["40%"];

  ngOnInit(): void {
    this.rebuildArrays();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["rows"] || changes["columns"] || changes["type"]) {
      this.rebuildArrays();
    }
  }

  trackByIndex(index: number): number {
    return index;
  }

  private rebuildArrays(): void {
    const rowCount = Math.max(1, Number(this.rows) || 1);
    const colCount = Math.max(1, Number(this.columns) || 1);
    this.rowsArray = Array.from({ length: rowCount }, (_, i) => i);
    this.columnsArray = Array.from({ length: colCount }, (_, i) => i);
    this.chartBarHeights = this.columnsArray.map(
      (_, i) => `${30 + ((i * 17) % 50)}%`
    );
  }
}
